import { getFromStorage, setInStorage } from 'ha/utils/storage';
import { fetchUserBillingInfo } from 'ha/modules/AuthLogic/actions';
import {
  getIsUserInformationLoading,
  getIsAuthenticated,
} from 'ha/modules/AuthLogic/selectors';
import { open, close } from 'ha/modules/ModalsLogic/actions';

import { shouldDisplayModal } from '../selectors';
import { MODAL_NAME, MODAL_DELAY, STORAGE_KEY, Actions } from '../constants';
import { openModal } from '../actions';

// at any given time only one timeout should be active,
// otherwise the modal could open more times than expected
let timer;
const openAfterX = ({ dispatch }, delay, pageName) => {
  clearTimeout(timer);

  timer = setTimeout(() => dispatch(openModal(pageName)), delay);
};

// open only after right time passed, only if user is logged in
//
// delayOpen :: (store: Redux.Store, action: Redux.Action<any>) => Promise<void>
const delayOpen = (store, action) => {
  if (!getIsAuthenticated(store.getState())) {
    return Promise.resolve();
  }

  const { pageName } = action.payload;

  const lastOpen = new Date(getFromStorage(STORAGE_KEY) || 0).getTime();
  const sinceLastOpen = Date.now() - lastOpen;

  if (sinceLastOpen >= MODAL_DELAY) {
    // do not fetch user's billing info, if there is one already fired
    if (getIsUserInformationLoading(store.getState())) {
      return Promise.resolve();
    }

    return store.dispatch(fetchUserBillingInfo()).then(() => {
      if (shouldDisplayModal(store.getState(), pageName)) {
        store.dispatch(open(MODAL_NAME));
      }
      // store last time open even when we shouldn't open to prevent
      // calling all the time for users that shouldn't see the modal
      setInStorage(STORAGE_KEY, Date.now());
    });
  }

  openAfterX(store, sinceLastOpen, pageName);

  return Promise.resolve();
};

// close modal, store time and re-open after right time passed,
// only if user is logged in
//
// closeAndOpen :: (store: Redux.Store, action: Redux.Action<any>) => Promise<void>
const closeAndOpen = (store, action) => {
  if (getIsAuthenticated(store.getState())) {
    store.dispatch(close(MODAL_NAME));
    setInStorage(STORAGE_KEY, Date.now());
    store.dispatch(openModal(action.payload.pageName));
  }

  return Promise.resolve();
};

const delayWeWantToPayModal = store => next => action => {
  switch (action?.type) {
    case Actions.OPEN:
      return delayOpen(store, action);

    case Actions.CLOSE:
      return closeAndOpen(store, action);

    default:
      next(action);

      return Promise.resolve();
  }
};

export { delayWeWantToPayModal };
